import React from 'react'
import { Button, Col, Form, Row, Card, CardBody } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'
import CompleteSchedule from "../../design/Schedule/CompleteSchedule"
import Loader from "../../design/Loader/Loader"
import { Link } from "react-router-dom"
import { useSelector } from 'react-redux'

export default function CourtFormStep2({state, statetype, usertype, isAddingOrEditing, submit, setState, removeSchedule, addSchedule, handleDayCheck, handleScheduleInputChange, onPeriodChange, handleRemoveBlockedRange, handleAddBlockedRange}) {
    const { t } = useTranslation()
    const { commission } = useSelector(state => state.commissions)

    return (
        <Form onSubmit={submit}>
            <Card>
                <CardBody>
                    <CompleteSchedule 
                        value={state} 
                        removeSchedule={removeSchedule} 
                        addSchedule={addSchedule} 
                        handleDayCheck={handleDayCheck} 
                        onScheduleInputChange={handleScheduleInputChange} 
                        onPeriodChange={onPeriodChange} 
                        handleRemoveBlockedRange={handleRemoveBlockedRange} 
                        handleAddBlockedRange={handleAddBlockedRange}
                        uiVariant="court"
                        commission={commission}
                    />
                </CardBody>
                <Row className="my-3">
                    <Col xs={6}>
                        <Link to={usertype === 'superadmin' ? `/${t("url.admin.admin")}/${t("url.admin.club")}/${t("url.admin.courts")}` : `/${t("url.club.club")}/${t("url.club.courts")}`}><Button variant="default" className="w-100 mt-3">{t('courts.backtolist')}</Button></Link>
                    </Col>
                    <Col xs={6}>
                        {isAddingOrEditing ?
                            <Loader/>
                        :
                            <Button type="submit" variant="primary" className='mt-3 w-100'>
                                {t('global.save')}
                            </Button>
                        }
                    </Col>
                </Row>
            </Card>
        </Form>
    )  
}
